const config = {
  backendUrl:
    process.env.REACT_APP_API_BASE_URL || "https://wms.cscindia.in/node-api"
};

export const REPORT_EXPORT_MAP = {
  accepted: {
    csv: "/api/reports/accepted/export/csv",
    excel: "/api/reports/accepted/export/excel",
    ppt: "/api/reports/accepted/export/ppt",
  },
  inventory: {
    csv: "/api/reports/inventory/export/csv",
    excel: "/api/reports/inventory/export/excel",
    ppt: "/api/reports/inventory/export/ppt",
  },
};

export default config;